import { render } from "./TabPlaylist.vue?vue&type=template&id=f05ec56c&scoped=true"
import script from "./TabPlaylist.vue?vue&type=script&lang=js"
export * from "./TabPlaylist.vue?vue&type=script&lang=js"

import "./TabPlaylist.vue?vue&type=style&index=0&id=f05ec56c&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-f05ec56c"

export default script